export const locales = ["en", "es"] as const;
export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = "en";

export const localeNames: Record<Locale, string> = {
  en: "English",
  es: "Español",
};

export const localeFlags: Record<Locale, string> = {
  en: "🇺🇸",
  es: "🇪🇸",
};

/**
 * Type guard to check if a string is a valid locale.
 *
 * @param locale - The string to check
 * @returns True if the locale is valid, false otherwise
 *
 * @example
 * ```typescript
 * const userLocale = "en";
 * if (isValidLocale(userLocale)) {
 *   // userLocale is now typed as Locale
 *   console.log(localeNames[userLocale]);
 * }
 * ```
 */
export function isValidLocale(locale: string): locale is Locale {
  return locales.includes(locale as Locale);
}